// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__rDIGM"};